import { State } from '../../types';

export const tennessee: State = {
  name: 'Tennessee',
  abbreviation: 'TN',
  terms: [
    {
      word: 'Beersheba Springs',
      phonetic: 'BURSH-uh-buh Springs',
      // audioUrl: '/audio/beersheba_springs.mp3',
      description: 'A town in Grundy County, often mispronounced due to its unique spelling. Locals pronounce it as "BURSH-uh-buh Springs."'
    },
    {
      word: 'Celina',
      phonetic: 'suh-LY-nuh',
      // audioUrl: '/audio/celina.mp3',
      description: 'A city in Clay County, pronounced as "suh-LY-nuh," not "suh-LEE-nuh."'
    },
    {
      word: 'Demonbreun Street',
      phonetic: 'de-MUN-bree-un',
      // audioUrl: '/audio/demonbreun_street.mp3',
      description: 'A street in Nashville, pronounced as "de-MUN-bree-un," often mispronounced due to its French origin.'
    },
    {
      word: 'Giles County',
      phonetic: 'JAHYLS County',
      // audioUrl: '/audio/giles_county.mp3',
      description: 'A county in Middle Tennessee, pronounced with a soft "G" as "JAHYLS County."'
    },
    {
      word: 'La Vergne',
      phonetic: 'luh-VERN',
      // audioUrl: '/audio/la_vergne.mp3',
      description: 'A city in Rutherford County, pronounced as "luh-VERN," despite its French-looking spelling.'
    },
    {
      word: 'Lafayette',
      phonetic: 'luh-FAY-it',
      // audioUrl: '/audio/lafayette.mp3',
      description: 'A city in Macon County, pronounced as "luh-FAY-it," differing from the French pronunciation.'
    },
    {
      word: 'Lebanon',
      phonetic: 'LEB-nun',
      // audioUrl: '/audio/lebanon.mp3',
      description: 'A city in Wilson County, pronounced as "LEB-nun," not like the country Lebanon.'
    },
    {
      word: 'Maryville',
      phonetic: 'MURR-vuhl',
      audioUrl: '/audio/maryville.mp3',
      description: 'City in eastern Tennessee'
    },
    {
      word: 'Maury County',
      phonetic: 'Mu-ry',
      // audioUrl: '/audio/maury_county.mp3',
      description: 'Locally pronounced as "Murray County."'
    },
    {
      word: 'Milan',
      phonetic: 'MY-lin',
      // audioUrl: '/audio/milan.mp3',
      description: 'A city in Gibson County, pronounced as "MY-lin," not like the Italian city.'
    },
    {
      word: 'Ocoee River',
      phonetic: 'Oh-co-weee',
      // audioUrl: '/audio/ocoee_river.mp3',
      description: 'A river known for its whitewater rafting.'
    },
    {
      word: 'Shelbyville',
      phonetic: 'SHEB-vull',
      // audioUrl: '/audio/shelbyville.mp3',
      description: 'Locally pronounced differently than spelled.'
    }
  ]
};